import React from 'react';
import './App.css';

function App() {
  return (
    <div className="landing-page">
		<div className="page-content">
			<h1>DESCUBRÍ MDP</h1>
			<p>
				Pronto podras recorrer  
			</p>
			<h3>Mar del Plata</h3>
			<p>
				con otra mirada
			</p>
		</div>
	</div>
  );
}

export default App;
